<template>
  <view class="package-channel-wrapper">
    <view class="package-intro">
      <view class="intro-title"> 抢票加速 </view>
      <view class="intro-content">
        <hl-text commonStyle="{{introCommonStyle}}" hlColor="{{introHlColor}}" text="{{introText}}" />
      </view>
    </view>
    <view class="package-select">
      <block wx:for="{{list}}" wx:key="index">
        <view class="package-select-item" 
          wx:class="{{{'active': selectPackageIndex === index }}}"
          bindtap="handleClick(item,index)">
          <view class="item-title">{{item.status_name}}</view>
          <view class="item-price" wx:if="{{item.status}}">
            <view class="item-price-after">¥{{item.show_price}}</view>
            <view wx:if="{{item.amount}}" class="item-price-before">¥{{item.price}}</view>
          </view>
          <view  wx:if="{{selectPackageIndex === index}}" class="active-wrap">
            <image class="active-image" src="{{activeIcon}}" />
          </view>
          <image wx:if="{{item.recommend == 1}}" class="defalut-image" src="{{defalutICon}}" />
        </view>
      </block>
    </view>
    <view class="package-tips">
      <hl-text commonStyle="{{tipsCommonStyle}}" hlColor="{{tipsHlColor}}" text="{{tipsText}}" />
    </view>
  </view>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'
  import store from '@/store'

  createComponent({
    props: {},
    data() {
      return {
        introHlColor:'#333333',
        tipsHlColor:'#FF5900',
        introCommonStyle: {
          color: '#666666'
        },
        tipsCommonStyle:{
          color: '#333333'
        },
        activeIcon:"https://ut-static.udache.com/webx/sfc/xlrJai5eoFFVAo6v-C5bt.png",
        defalutICon:"https://ut-static.udache.com/webx/sfc/jj3HzfM7DERqv9F1AteEm.png"
      }
    },
    created() {
      const index = this.list.findIndex(item=> item.recommend == 1)
      this.setAddedServiceSource(['make_order__accelerate']) // 埋点数据-记录选择加速包位置
      this.setSelectPackageIndex(index)
      this.setSelectPackageItem(this.list[index])
    },
    computed: {
      ...store.mapState({
        packageInfo: 'train.packageInfo',
        selectPackageItem: 'train.selectPackageItem',//选中的加速包信息
        selectPackageIndex: 'train.selectPackageIndex',//选中的加速包信息索引
      }),
      tipsText(){
        return this.currentItem?.amount
          ? `默认为您使用账户内${this.currentItem.amount}个加速包，可抵扣{{${this.currentItem.deduct_price/100}}}元`
          : ''
      },
      currentItem(){
        return this.list[this.selectPackageIndex]
      },
      introText() {
        return`预计领先{{${this.currentItem?.percent}%}}的用户` 
      },
      list(){
        return this.packageInfo.packages || []
      }
    },
    methods: {
      ...store.mapMutations({
        setSelectPackageItem: 'train.setSelectPackageItem',
        setSelectPackageIndex:'train.setSelectPackageIndex',
        setAddedServiceSource: 'makeOrder.setAddedServiceSource',
      }),
      handleClick(item,index) {
        this.setAddedServiceSource(['make_order__accelerate']) // 埋点数据-记录选择加速包位置
        this.setSelectPackageIndex(index)
        this.setSelectPackageItem(item)
      }
    }
  })
</script>

<style scoped lang="stylus">
  .package-channel-wrapper
    width 100%
    box-sizing border-box
    padding 0 16px 0 14px
    display flex
    flex-direction column
    justify-content space-between
    border-radius 8px
    margin-bottom 8px
    padding 16px 14px
    background-color #fff
    .package-intro
      display flex
      align-items center
      margin-bottom 16px
      .intro-title
        font-family PingFang SC
        font-size 16px
        font-weight 600
        line-height 16px
        margin-right 8px
        color #333333
      .intro-content
        font-family PingFang SC
        font-size 12px
        font-weight 400
        line-height 12px
        color #666666
    .package-select
      display grid
      grid-template-rows: auto auto
      grid-template-columns: repeat(3, 1fr)
      grid-gap 9px 8px
      .package-select-item
        font-family PingFang SC
        height 48px
        border-radius 8px
        opacity 1
        background #FFFFFF
        border 0.5px solid #D1DBE9
        backdrop-filter blur(27.2px)
        display flex
        flex-direction column
        justify-content center
        align-items center
        position relative
        &:last-child
          border: 0.5px solid rgba(120, 62, 23, 0.2)
          .item-title
            color #783E17
          .item-price
            .item-price-after
              color rgba(120, 62, 23, 0.9)
            .item-price-before
              color rgba(120, 62, 23, 0.5)
          .active-wrap
            background linear-gradient(143deg, #DC9626 -64%, #F9CD87 84%)
        &:last-child.active
          background: linear-gradient(168deg, #FEF9F2 8%, #FFF1DB 136%)
          border: 1px solid #F9CD87
        &:last-child:after
          content ''
          position absolute
          width 45px
          height 38px
          right 0px
          bottom 0px
          background-image url("https://ut-static.udache.com/webx/sfc/U4JbSF20KzyMjnBAQP2FD.png")
          background-size 100% 100%
          border-radius 0 0 8px 0
        .item-title
          font-family 'PingFang SC'
          font-size 14px
          font-weight 500
          line-height 14px
          text-align center
          letter-spacing 0px
          color #333333
        .item-price
          display flex
          flex-direction row
          margin-top 3px
          align-items baseline
          .item-price-after
            font-family 'PingFang SC'
            font-size 12px
            font-weight normal
            line-height 12px
            text-align center
            letter-spacing 0px
            margin-right 3px
            color #666666
          .item-price-before
            font-family 'PingFang SC'
            font-size 9px
            font-weight normal
            line-height 9px
            text-align right
            letter-spacing 0px
            color #999999
            text-decoration line-through
      .active
        background linear-gradient(0deg, rgba(254, 245, 234, 0.5), rgba(254, 245, 234, 0.5))
        box-sizing border-box
        border 1px solid #FF5900
        .active-wrap
          position absolute
          height 11px
          width 15px
          right -1px
          bottom -1px
          background #FF6400
          border-radius 8px 0
        .active-image
          width 5.5px
          height 4px
          position absolute
          right 3.5px
          bottom 2.5px
          z-index 2
        .item-price
          .item-price-after
            color #333333
      .defalut-image
        width 30px
        height 17px
        position absolute
        top -6px
        left -0.5px
    .package-tips
        font-family PingFang SC
        font-size 11px
        font-weight 400
        line-height 12px
        letter-spacing 0px
        color #333333
        margin-top 8px

</style>

<script name="json">
    module.exports = {
      component: true,
      usingComponents: {
        'hl-text': '@/components/hl-text'
      }
    }
</script>